export enum BarcodeType {
    NoBarcode = 0,
    Code128B = 1,
    Interleaved2of5 = 2,
    QRCode = 3
}